exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".giftcard-check-balance-container .substrate__popup-change-pass input {\n  border: 1px solid #BEBEBE;\n  width: 100%;\n  height: 50px;\n}\n@media screen and (max-width: 375px) {\n.giftcard-check-balance-container .check-card {\n    margin-left: auto;\n    margin-right: auto;\n}\n}", ""]);

// exports
